var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_395_2439",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_395_2439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 20V16.6666H18.3333V20H1.66663ZM4.99996 13.3333H6.16663L12.6666 6.85413L11.4791 5.66663L4.99996 12.1666V13.3333ZM3.33329 15V11.4583L12.6666 2.14579C12.8194 1.99301 12.9965 1.87496 13.1979 1.79163C13.3993 1.70829 13.6111 1.66663 13.8333 1.66663C14.0555 1.66663 14.2708 1.70829 14.4791 1.79163C14.6875 1.87496 14.875 1.99996 15.0416 2.16663L16.1875 3.33329C16.3541 3.48607 16.4757 3.66663 16.552 3.87496C16.6284 4.08329 16.6666 4.29857 16.6666 4.52079C16.6666 4.72913 16.6284 4.93399 16.552 5.13538C16.4757 5.33677 16.3541 5.52079 16.1875 5.68746L6.87496 15H3.33329Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcom);
export default __webpack_public_path__ + "static/media/edit_icom.68df03523e7c0cefeb625ec94a473ce9.svg";
export { ForwardRef as ReactComponent };